import React from 'react';
import {
  Checkbox, FormControl, FormControlLabel, FormHelperText, Paper, Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';

const getBackgroundColor = (value, invalid) => {
  if (value) {
    return 'success.light';
  }

  if (invalid) {
    return 'error.light';
  }

  return 'info.light';
};

const Consent = ({
  control = undefined, consentLabel, name = 'consent', required = true,
}) => (
  <Controller
    name={name}
    control={control}
    rules={{ required: required ? 'Checking this box is required to continue.' : false }}
    defaultValue={false}
    render={
      ({
        field,
        fieldState,
      }) => (
        <FormControl
          error={fieldState.invalid}
          component="fieldset"
        >
          <Paper
            variant="outlined"
            sx={{ bgcolor: getBackgroundColor(field.value, fieldState.invalid) }}
          >
            <FormControlLabel
              sx={{
                gap: 1, m: 0, p: 2, alignItems: 'flex-start',
              }}
              label={(
                <Typography variant="caption">
                  {consentLabel}
                </Typography>
              )}
              control={(
                <Checkbox
                  size="medium"
                  color="success"
                  inputRef={field.ref}
                  onBlur={field.onBlur}
                  onChange={field.onChange}
                  value={field.value}
                  name={field.name}
                />
              )}
            />
          </Paper>
          { fieldState.invalid && <FormHelperText>{fieldState.error.message}</FormHelperText> }
        </FormControl>
      )
    }
  />
);

export default Consent;
